import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { UsageLimitService } from '../../services/usage-limit/usage-limit.service';

export const fontesTrafegoGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const usageLimitService = inject(UsageLimitService);
    const router = inject(Router);

    return usageLimitService.ensureUsageLoaded().pipe(
        map(() => (authService.canAccessFontesTrafego() ? true : router.parseUrl('/v2'))),
    );
};
